import { Product, Profile, RequiredAccess } from '@news-mono/web-common'
import React from 'react'
import { FeatureToggle } from '../../feature-toggling/Toggle/Toggle'
import { StyledByline } from '../../publication/Byline/Byline.styled'
import { FundingType } from '../../templates/Publication/lib/get-funding-type'
import { useProduct } from '../../__product/useProduct'
import { BylineMail } from './components/BylineMail'
import { BylineProfile } from './components/BylineProfile'
import { BylineText } from './components/BylineText'

export interface BylineProps {
    text?: string
    profile?: Profile[]
    fundingType?: FundingType
    source?: string
    timestamp?: string
    timestampUpdated?: string
    url?: string
    title?: string
    isFullWidth: boolean
    requiredAccess?: RequiredAccess
    allowCommenting: boolean
}

export const Byline: React.FC<BylineProps> = ({
    text,
    isFullWidth,
    requiredAccess,
    profile,
    fundingType,
    source,
    timestamp,
    timestampUpdated,
    title,
    url,
    allowCommenting,
}) => {
    const product = useProduct()
    const isSevenNews = product === Product.SevenNews

    if (!text && !source && !fundingType) {
        return null
    }

    return (
        <StyledByline isFullWidth={isFullWidth}>
            {!isSevenNews && profile && <BylineProfile profile={profile} />}
            <BylineText
                inlineTimestamp={isSevenNews}
                profile={profile}
                fundingType={fundingType}
                source={source}
                timestamp={timestamp}
                text={text}
                requiredAccess={requiredAccess}
                timestampUpdated={timestampUpdated}
                allowCommenting={allowCommenting}
            />
            {!isSevenNews && (
                <FeatureToggle
                    feature="email-author"
                    on={() => (
                        <BylineMail
                            profiles={profile}
                            url={url}
                            title={title}
                        />
                    )}
                />
            )}
        </StyledByline>
    )
}
Byline.displayName = 'Byline'
